<template>
	<div class="modal-content sm_padding">
		<div class="modal-header">
			<button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
			<h4 class="modal-title text-center">Envie um convite para {{ name }}</h4>
		</div>
		<div class="modal-body">
			<div class="host-info">
				<div class="img">
					<img :src="photo" class="img-circle img-thumbnail" alt="profile-image">
				</div>
				<div class="content text-left">
					<h3 class="m-b-0 m-t-0">{{ name }}</h3>
					<span v-if="online"><i class="fa fa-circle online m-t-5 m-b-5"></i> Online agora</span>
					<span v-else class="font-13 m-t-5 m-b-5">Online {{ last_activity }}</span>
					<span v-if="verified" class="verified m-b-5"><img src="/images/verified.png" alt=""> Conta Verificada</span>
					<span class="badge badge-gray m-b-15">Taxa de Resposta: {{ response_rate }}
						<i data-toggle="tooltip" data-placement="top" title="Porcentagem de contatos que esta pessoa respondeu." class="far fa-question-circle"></i>
					</span>
				</div>
			</div>
			<transition name="fade">
				<div v-if="invitation">
					<div v-if="invitation.fk_status == 3">
						<div class="dv_msg msg_success text-center">
							<img class="icon" src="/images/sent.svg" alt="">
							<h4 class="text-custom">Mensagem enviada com sucesso. E agora?</h4>
							<p>Enviamos sua mensagem para {{ name }}. Fique atento(a) a sua caixa de mensagens e notificações para saber quando {{ name }} te responder.</p>
							<div>
								<hr>
								<p>Aproveite e baixe nosso app, assim você é notificado quando {{ name }} atualizar este convite 😉!</p>
								<div class="row link_app m-b-15">
									<a href="https://play.google.com/store/apps/details?id=com.webquarto.b2c.app&referrer=utm_source%3Dwebquarto_website%26utm_medium%3Dwebsite_footer" target="_blank">
										<img src="https://play.google.com/intl/en_us/badges/static/images/badges/pt-br_badge_web_generic.png" alt="" width="144" srcset="">
									</a>
									<a href="https://apps.apple.com/br/app/webquarto/id1490298196" target="_blank">
										<img src="https://www.webquarto.com.br/images/appstore.png" alt="" width="120">
									</a>
								</div>
							</div>
							<a :href="'/mensagens/' + fk_user" class="btn btn-success btn-block btn-message-sent">Ver Caixa de Mensagens</a>
						</div>
					</div>
				</div>
			</transition>

			<transition name="fade">
				<div v-if="!msg_success" class="m-t-20">
					<p>Se {{ name }} tiver interesse, vocês poderão negociar o aluguel pelo chat do WebQuarto.</p>
                    <p class="m-b-5"><b>Mensagens Salvas</b> <i class="far fa-question-circle"></i></p>
                    <div class="saved-messages m-b-20">
                        <span v-for="msg, i in saved_messages" @click="setMessage(msg)" v-bind:key="i" class="label label-success m-r-10 m-b-5">{{ msg.message | truncate(45)}}</span>
                        <button class="btn btn-sm btn-link btn-white" type="button" @click="openSavedMessagesModal()">+ Adicionar Nova</button>
                    </div>
					<form v-on:submit.prevent="sendMessage()">
						<div class="dv_msg_success text-left m-t-15">
							<div class="form-group" v-bind:class="{'has-error': errors.has('message')}">
								<textarea name="message" v-validate="'required'" class="form-control" v-model="form.message" :placeholder="'Digite aqui sua mensagem para ' + name + '.'" rows="4"></textarea>
								<span class="help-block text-left" v-show="errors.has('message')">
									<strong>{{ errors.first('message') }}</strong>
								</span>
							</div>
						</div>

						<button type="submit" class="btn btn-success btn-invitation btn-lg btn-block waves-effect waves-light ladda-button">
							<span class="ladda-label">Enviar Mensagem</span>
						</button>

                        <p v-if="!premium_host" class="text-mutted m-t-10 m-b-20 text-left">
                            <b>Custo</b>: <span class="coins-amount">{{ ic_amount }}<img src="/images/icone_moeda.svg" alt="" /></span> <a class="btn-link m-l-10" target="_blank" href="https://ajuda.webquarto.com.br/article/149-o-que-sao-as-moedas-webquarto-e-como-funcionam">O que é isso?</a>
                        </p>
					</form>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
	var Ladda = require('../../../../../../legacy/node_modules/ladda');
	export default {
		props: ['name',
            'photo',
            'fk_roommate',
            'online',
            'authenticated',
            'response_rate',
            'last_activity',
            'verified',
            'fk_user',
            'ic_amount',
            'premium_host'],

		data: function () {
			return {
				invitation: false,
				msg_success: false,
                saved_messages: [],
				form: {
					message: '',
					fk_property: null,
					fk_user: this.fk_user,
					fk_roommate: this.fk_roommate,
					initial_message: 1,
					target: 'r'
				}
			};
		},
        filters: {
            truncate: function(string, value) {
                if (string.length > value)
                    return string.substring(0 , value) + '...';
                else
                    return string;
            }
        },
		methods: {
            openSavedMessagesModal() {
                EventBus.$emit('open-modal', 'saved-messages-modal');
            },
            loadSavedMessages() {
                axios.get('/message/saved-messages').then(res => {
                    if (res.data)
                        this.saved_messages = res.data.messages;
                });
            },
            setMessage(obj) {
                this.form.message = obj.message;
            },
			canUserMessage() {
				if (!this.authenticated) {
					EventBus.$emit('open-modal', 'register-modal');
					window.dataLayer.push({
						'event': 'show_login_modal',
						'event_category': 'property_ad_events',
						'event_label': 'send_message'
					});
					return false;
				}

				return true;
            },
			sendMessage () {
				if (!this.canUserMessage())
                    return;

				var form = this.form;
				this.$validator.validateAll().then((result) => {
					if (!result)
						return;

					let l = Ladda.create( this.$el.querySelector('.ladda-button') );
					l.start();

					axios.post('/message/send-message', form).then((response) => {
						l.stop();
						var data = response.data;
						if (data.success) {
							window.App.success('Mensagem enviada com sucesso! Fique atento a sua Caixa de Mensagens.');
							window.dataLayer.push({
								'event': 'init_contact_ad',
								'event_category': 'roommate_ad_page',
								'event_label': 'init_contact_ad'
							});
							this.msg_success = true;
							this.invitation = data.invitation;

							EventBus.$emit('update-message-sent', null, { res: true });

						} else {
                            if (data.error == 'insuficient_credits') {
                                EventBus.$emit('open-modal', 'need-credits-modal');
                            }
                        }
					}).catch(error => {
						l.stop();

						if (error.response && error.response.status == 401) {
							EventBus.$emit('open-modal', 'register-modal');
							window.dataLayer.push({
								'event': 'show_login_modal',
								'event_category': 'roommate_ad_page',
								'event_label': 'send_message',
							});
							EventBus.$emit('close-modal');

						} else if (error.response && error.response.status == 403) {
							window.App.error('Você não pode enviar uma mensagem para esta pessoa!');
						} else
							window.App.error('Ocorreu um erro ao enviar sua mensagem. Atualize esta página e tente novamente!');
					});
				});
			},
		},
		created() {
            this.loadSavedMessages();
			this.$validator.localize('pt_BR', {
				messages: {
					required: 'Preencha uma mensagem no campo acima.',
				},
			});
		},
	}
</script>


<style lang="scss" scoped>
    .saved-messages .label{
        font-size: 12px;
        font-weight: normal;
        cursor: pointer;
        display: inline-block;
        padding: 5px 10px 4px;
    }

    .coins-amount {
        font-weight: bolder;
        color: #5f6261;

        img {
            margin-left: 4px;
            width: 14px;
            height: 14px;
        }
    }

    .btn-outline-orange {
        border-color: #FFC14D !important;
    }

    .w-9 {
        width: 20px;
        margin-left: 5px;
    }

	.sm_padding {
		padding: 15px !important;;
	}

	.app img.icon {
		width: 45px;
	}

	.dropdown-menu{
		.form-group{
			padding-left: 10px;
		}
	}

	.dropdown-myads {
		width: 100%;
		padding: 10px;
		max-height: 500px;
		overflow-y: scroll;
	}

	.propertyad_dropdown .btn{
		padding: 8px !important;
	}

	.row.link_app {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.dv_msg img.icon {
		width: 45px;
		margin-bottom: 15px;
	}

	.property_ad_item {
		display: flex;
		flex-direction: row;
		overflow: hidden;
		img {
			height: 50px;
			max-width: 50px;
		}

		.property_ad_cnt {
			flex-direction: column;
			padding-left: 10px;
			text-overflow: ellipsis;
			width: calc(100% - 60px);
			text-align: left;

			p {
				margin: 0;
				width: 100%;
				white-space: nowrap;
			}
		}
	}

	.radio.adr {
		input[type=radio] {
			top: 17px;
		}

		label::before {
			top: 17px;
		}

		label::after {
			top: 20px;
		}
	}

	.host-info {

		display: flex;

		.img {
			margin-right: 15px;

			img {
				width: 75px;
			}
		}

		.content {
			display: flex;
			flex-direction: column;
		}

	}


	.row.link_app {
		display: flex;
		align-items: center;
		margin-top: 15px;

		.col-xs-6 {
			height: 50px;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
</style>
